import React, { useState, useEffect, useCallback } from "react";
import { Nav, Button, Modal, Container } from "react-bootstrap";
import NavDropdown from "react-bootstrap/NavDropdown";
import Navbar from "react-bootstrap/Navbar";
import styled from "styled-components";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index.js";
import "./index.css";

const NavWrapper = styled.div`
// .navbar-dark .navbar-nav .nav-link:focus, .navbar-dark .navbar-nav .nav-link:hover {
//     color: rgb(8, 63, 136) !important;
// }
.navbar-dark .navbar-nav .nav-link{
    color: white;
    z-index: 1200;
    // font-weight:600;
    white-space:nowrap;
}
// .nav-item.show > a{
//     color: #083F88!important;
// }
.navbar-expand-lg .navbar-nav .dropdown-menu{
    margin: 0px 0px 0 0px !important;
}
._3yQ6ipwnXEJX5uUyBeOBFR.btn.btn-primary.btn-md {
    font-weight: 600;
}
}
.dropdown-item.active, .dropdown-item:active {
    color: #fff;
    text-decoration: none;
    background-color:transparent;
    border-left: 4px solid #083F88;
    border-right: 4px solid #083F88;
    transition: all 0.1s linear;
    border-radius:2px;
}
.dropdown-item{
    border-bottom:2px solid transparent;
}
.dropdown-item:focus, .dropdown-item:hover{
    background-color:transparent;
}
 .dropdown-item:hover{
    border-bottom:2px solid  #083F88 !important;
    // color: #083F88 !important;
    // border-bottom: 1px solid #00AAE4 !important;
}
@media(max-width:767px){
    .dropdown-item{
        border-bottom:0px transparent !important;
    }
    .dropdown-item:hover{
        border-bottom: 0px transparent !important;
    }
}
#dropdown-item-button::after{
    content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAA8ElEQVQ4jWNgGAUowHLOVSHjmc+4cMkbz3zGZTnnqhCyGBOMYTD/vsDvP2w7mf5/26E99SoPNs2M/79s+vWHbZ/xzJsiGAaw/PpbycDAYPKf4b8tFzPbRmSXGM98xsX0/+tmBgZGZ0YGBn1GBuZSuD4Y4z/DhxoGBj5VRgbGwP8MDE5Ql3hxsAj+Y/z/ZdN/BkYniErGrR9+/q+D6WNEdeYZVob/fCsZGRgDoZL7IIYzOEHo/+sZGD+Fn003+Y3VAGyGIADj1g+//gffyVP9iSKKbgB2Q7BrxmkAqiFMbLg0EwTGM8+wGs88w0qyxqEFAFtSY2S3+RTSAAAAAElFTkSuQmCC");
    // vertical-align: middle;
    vertical-align: -0.09em ;
    border:none;
    margin-top:5px;
}
.show>.btn-primary.dropdown-toggle:focus {
    box-shadow: none;
    border-color:white;
}
.btn-primary:focus {
    border-color: white;
}
.btn-primary:not(:disabled):not(.disabled):active, .show>.btn-primary.dropdown-toggle {
    background: #fff;
    color: #0481b5;
    border:1px solid #fff;
    box-shadow:none;
}
.btn-primary:not(:disabled):not(.disabled).active:focus, .btn-primary:not(:disabled):not(.disabled):active:focus, .show>.btn-primary.dropdown-toggle:focus{
    background: #fff;
    color: #0481b5;
    border:1px solid #fff;
    box-shadow:none;
}
.channelsNav{
    .dropdown-submenu-container a.dropdown-submenu::after {
        position: absolute;
        right: 0;
        top: 0;
    }
.dropdown-menu{
    .dropdown-toggle::after {
        content: ">";
        vertical-align: middle;
        border: none;
        margin-top: 4px;
        font-weight: 600;
        color: #dddd;
        transform: rotate(0) !important;
    }
    padding-right:15px !important;
}
}
@media(min-width:1067px) and (max-width:1201px){
    .navbar-dark .navbar-nav .nav-link{
        font-size: 12px !important;
        font-weight:600;
    }
    .responsive-navbar-nav{
      margin-left:-2rem
    }
    }
    @media(min-width:992px) and (max-width:1067px){
        .navbar-dark .navbar-nav .nav-link{
            font-size: 12px !important;
            font-weight: 500;
            padding: 10px 5px;
        }
        .eEKJvu ._3yQ6ipwnXEJX5uUyBeOBFR.btn.btn-primary.btn-md {
            font-weight: 600;
            font-size: 14px;
        }
        .navbar-nav, .nav-link, .dropdown-item {
          font-family: 'Poppins', sans-serif;
          color: #083F88!important;
          padding-left: 8px !important;
      }
        }
@media(max-width:992px){
.navbar-dark .navbar-toggler{
background-color:#00AAE4;
// border-color:blue;
}
`;

export default function CustomNavbar(props) {
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [logoImage, setLogoImage] = useState("");

  const [show, setShow] = useState(false);
  const showDropdown = (e) => {
    setShow(!show);
  };
  const hideDropdown = (e) => {
    setShow(false);
  };
  const [show1, setShow1] = useState(false);
  const showDropdown1 = (e) => {
    setShow1(!show1);
  };
  const hideDropdown1 = (e) => {
    setShow1(false);
  };
  const [show2, setShow2] = useState(false);
  const showDropdown2 = (e) => {
    setShow2(!show2);
  };
  const hideDropdown2 = (e) => {
    setShow2(false);
  };

  useEffect(() => {
    if (window.innerWidth >= 768) {
      setLogoImage(
        "https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"
      );
    } else {
      setLogoImage(
        "https://resources.swmc.com/swmc-images/minified/SunWest41YearsofTrust-White.png"
      );
    }
  }, []);

  return (
    <>
      <NavWrapper>
        <Navbar
          collapseOnSelect
          expand="lg"
          fixed="top"
          // bg="dark"
          variant="dark"
          className="homepageNav"
        >
          <Container>
            <Navbar.Brand>
              <div className="d-flex">
                <div>
                  <a href="https://www.swmc.com/">
                    <img src={logoImage} className="main_logo" alt="swmc-logo" />
                  </a>
                </div>

              </div>
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="responsive-navbar-nav" />

            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="mr-auto" style={{ margin: "auto" }} />
              <Nav>
                <NavDropdown
                  title="About"
                  id="collasible-nav-dropdown"
                  className="dropdown"
                  show={show}
                  onClick={showDropdown}
                  onMouseEnter={showDropdown}
                  onMouseLeave={hideDropdown}
                >
                  <a
                    className="dropdown-item"
                    href="https://www.swmc.com/our-history"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Our History
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://www.swmc.com/why-sunwest"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Sucess Stories
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://www.swmc.com/careers"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Careers
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://www.swmc.com/contact-us"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Contact Us
                  </a>
                </NavDropdown>

                <NavDropdown
                  title="Loan Tools"
                  id="collasible-nav-dropdown"
                  show={show1}
                  onClick={showDropdown1}
                  onMouseEnter={showDropdown1}
                  onMouseLeave={hideDropdown1}
                >
                  <a
                    className="dropdown-item"
                    href="https://www.swmc.com/angelai/calculators"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Calculators
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://www.swmc.com/loan-programs"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Loan Products
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://www.swmc.com/blog/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Blog
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://sunwestmortgage.myloaninfo.com/loanmanager/glossary/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Glossary
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://www.swmc.com/faq"
                    target="_blank"
                    rel="noreferrer"
                  >
                    FAQ
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://www.swmc.com/theprocessor"
                    target="_blank"
                    rel="noreferrer"
                  >
                    The Processor
                  </a>
                </NavDropdown>
                <a
                  className="navbar-dark navbar-nav nav-link"
                  href="https://www.swmc.com/wholesale-lending"
                  target="_blank"
                  rel="noreferrer"
                >
                  Wholesale
                </a>
                <a
                  className="navbar-dark navbar-nav nav-link"
                  href="https://www.swmc.com/correspondent-lending"
                  target="_blank"
                  rel="noreferrer"
                >
                  Correspondent
                </a>

                <NavDropdown
                  title="Client Login"
                  id="collasible-nav-dropdown"
                  show={show2}
                  onClick={showDropdown2}
                  onMouseEnter={showDropdown2}
                  onMouseLeave={hideDropdown2}
                >
                  <a
                    className="dropdown-item"
                    href="https://seemyloanstatus.com/ReverseMortgage/jsp/extSeeMyLoanStatusLogin.jsf?loginByUsingView=CMOL"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Check My Loan Progress
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://sunwestmortgage.myloaninfo.com/loanmanager/login/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Make a Payment
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://www.swmc.com/loss-mitigation"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Servicing Portal
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://www.swmc.com/covid19-relief"
                    target="_blank"
                    rel="noreferrer"
                  >
                    COVID-19 Relief
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://www.swmc.com/property-insurance"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Property Insurance
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://www.swmc.com/sunsoft-login"
                    target="_blank"
                    rel="noreferrer"
                  >
                    ReverseSoft Login
                  </a>
                </NavDropdown>

                <a
                  className="navbar-dark navbar-nav nav-link"
                  href="https://www.swmc.com/login"
                  target="_blank"
                  rel="noreferrer"
                >
                  Partner Login
                </a>
              </Nav>
              <span className="nav-link active">
                <Button
                  variant="primary"
                  className="dblue"
                  onClick={() => {
                    props.setModalShow(true);
                  }}
                >
                  Apply Now
                </Button>
              </span>
            </Navbar.Collapse>
            <div className="desktop-AccessibilityMenu-show">
              <UserWayAccessibilityMenu color="black" width={50} height={50} />
            </div>
          </Container>
        </Navbar>
        <div className="mobile-AccessibilityMenu-show">
          <UserWayAccessibilityMenu color="black" width={50} height={50} />
        </div>
      </NavWrapper>

    </>
  );
}
